export const rebateWithAutoShipOrDelayedBillingRemainder = 0.01
export const maxQuantityOptionCount = 150
export const defaultMinQuantityAllowedInCart = 1
export const defaultMaxQuantityAllowedInCart = 1000
export const defaultQuantityIncrement = 1
export const defaultProductLabelDesignFeeSKU = 'Graphic Design Fee'
